var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-text",
        {
          staticClass: "text-center",
          staticStyle: {
            "font-size": "1.2em"
          }
        },
        [
          _c("p", [
            _vm._v(" Customer ID: "),
            _c(
              "span",
              {
                staticClass: "font-bold"
              },
              [_vm._v(_vm._s(this.SessionProfile.accountId))]
            )
          ]),
          _vm._v(" Support PIN: "),
          _vm.supportToken
            ? _c(
                "span",
                {
                  staticClass: "font-bold"
                },
                [_vm._v(_vm._s(_vm.supportToken))]
              )
            : _c(
                "gg-btn",
                {
                  attrs: {
                    small: "",
                    loading: _vm.loadingSupportToken
                  },
                  on: {
                    click: function click($event) {
                      $event.stopPropagation()
                      return _vm.requestToken($event)
                    }
                  }
                },
                [_vm._v(" Request ")]
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }